<template>
  <div id="login-selection">
    <div class="login-selection-container">
      <LeftView v-bind:coverImage="coverImage" />
      <div class="right-view">
        <have-account v-bind:haveAccountData="haveAccountData" />
        <onboarding-form

          class="login-form"
          v-bind:errorExists="errorExists"
          v-bind:formData="formData"
          v-on:changeInput="handleChange"
          v-bind:errors="errors"
          v-on:setErrorExists="setErrorExists"
          v-bind:formTitleText="formTitleText"
          v-bind:formSubtext="formSubtext"
          v-bind:formFields="formFields"
          v-bind:hintText="hintText"
          v-bind:baseLink="baseLink"
          v-bind:buttonText="buttonText"
          v-on:userData="userData"
          :toggle="toggle"
          v-on:toggleAnimation="lockChild"
        />
      </div>
    </div>
  </div>
</template>
<script>
import LeftView from '../components/SignupSelection/LeftView.vue';
import coverImage from '../assets/images/login-cover-image.jpg';
import HaveAccount from '../components/body/HaveAccount.vue';
import OnboardingForm from '../components/body/OnboardingForm.vue';

export default {
  name: 'Login',
  components: {
    LeftView,
    HaveAccount,
    OnboardingForm,
  },
  data() {
    return {
      formData: {
        emailAddress: null,
        password: null,
      },
      errors: {
        emailError: null,
        passwordError: null,
      },
      errorExists: false,
      toggle: false,
      haveAccountData: {
        haveAccountTitle: 'Don\'t have an account?',
        haveAccountButtonText: 'Sign Up',
        haveAccountLink: '/signup',
      },
      formTitleText: 'Welcome back!',
      formSubtext: 'Please log in to your account to continue.',
      formFields: [
        { name: 'emailAddress', placeholder: 'Email', type: 'email', errorName:'emailError' },
        { name: 'password', placeholder: 'Password', type: 'password', errorName:'passwordError' },
      ],
      baseLink: { link: '/forgot-password', text: 'Forgot Password?' },
      hintText: '',
      buttonText: 'Log in',
      coverImage: coverImage,
    };
  },
  methods: {
    setErrorExists(value) {
      this.errorExists = value;
    },

    handleChange(data) {
      switch (data.name) {
        case 'emailAddress':
          this.formData.emailAddress = data.value;
          break;

        case 'password':
          this.formData.password = data.value;
          break;
      }
    },
    permitChild: function () {
      this.toggle = true;
    },
    lockChild: function () {
      this.toggle = false;
    },
    userData(data) {
      this.$store
          .dispatch('login', data)
          .then((res) => {
            this.permitChild();
            if (res.response) {
              this.$toastr.success(res.response.message, 'Success');
              setTimeout(() => {
                // Check if there is a shared job link and created job (for job reviews) link to redirect to during login, and save in a variable
                const sharedJobLinkId = localStorage.getItem('sharedJobLinkId');
                const createdJobLinkId = localStorage.getItem('createdJobLinkId');

                // Delete the job redirect links from localStorage after found and saved into 'sharedJobLinkId' and 'createdJobLinkId'
                if (sharedJobLinkId) {
                  localStorage.removeItem('sharedJobLinkId');
                }
                if (createdJobLinkId) {
                  localStorage.removeItem('createdJobLinkId');
                }

                createdJobLinkId
                ? this.$router.push(`/user/jobs/${createdJobLinkId}/review`)
                : sharedJobLinkId
                ? this.$router.push(`/user/jobs/${sharedJobLinkId}/apply`)
                : this.$router.push('/user/dashboard');
              }, 1000);
            } else {
              res.error.error
                ? this.$toastr.error(res.error.error, 'Login Failed')
                : this.$toastr.error(
                    'Couldn\'t establish connection',
                    res.error.message
                );
            }
          })
          .catch((error) => {
            throw error;
          });
    },
  },
};
</script>
<style scoped>
  .login-selection-container {
    display: flex;
  }
  @media only screen and (min-width: 991px) {
    .login-form {
      padding-top: 10%;
    }
  }
</style>
